/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.9",
    versionName: "0.2.0-nightly.2025.7.9",
    versionChannel: "nightly",
    buildDate: "2025-07-09T00:09:28.760Z",
    commitHash: "5764bfa040b1abff8958718975f369ef84323bf2",
};
